<template>
  <div>
    <div class="dashboard-title">{{ $t("dashboard.details.title") }}</div>
    <div class="transaction-info">
      <div
        class="balance-card w-100 w-md-50"
        :class="balancePage == 'recharge' ? 'yellow-balance' : 'blue-balance'"
      >
        <p class="balance-title">{{ balanceTitle }}</p>
        <div class="balance-area">
          <span class="currency" v-if="(balanceType == 'usd')">USD</span>
          <span class="balance">{{ numberWithCommas(balance) }}</span>
          <span class="equivalence" v-if="(equivalence != '')">${{ numberWithCommas(equivalence) }}</span>
        </div>
        <div class="btn" v-if="canConvert" :class="convertType">
          <span v-if="convertType == 'USDToGCoin'" @click="toConvert('USDToGCoin')">{{
            $t("dashboard.details.USDToGCoin")
          }}</span>
          <span v-if="convertType == 'GCoinToUSD'" @click="toConvert('GCoinToUSD')">{{
            $t("dashboard.details.GCoinToUSD")
          }}</span>
        </div>
      </div>
      <div class="search-transaction w-100 w-md-50">
        <p>{{ $t("dashboard.details.search") }}</p>
        <div class="search">
          <input
            type="text"
            id="keywords"
            :placeholder="$t('dashboard.details.searchFor')"
          />
          <img class="search-icon" @click="getData" src="../../assets/icon-search.svg" alt="Search">
        </div>
        <div class="d-flex gap-2 w-100">
          <BFormSelect
            v-model="transactionType"
            :options="options"
            class="w-50"
            :placeholder="$t('dashboard.details.type')"
          ></BFormSelect>
          <BFormDatepicker
            v-model="date"
            class="w-50"
            :date-format-options="{
              year: 'numeric',
              month: 'numeric',
              day: 'numeric',
            }"
            :locale="$i18n.locale"
            :placeholder="$t('dashboard.details.date')"
          ></BFormDatepicker>
        </div>
      </div>
    </div>
    <div class="transaction-table">
      <b-table striped hover :items="transactions" :fields="fields"></b-table>
    </div>
  </div>
</template>

<script>
import { BFormDatepicker, BFormSelect, BTable } from "bootstrap-vue";

export default {
  components: {
    BFormSelect,
    BFormDatepicker,
    BTable,
  },
  data() {
    return {
      balancePage: "",
      balanceTitle: "",
      balanceType: "",
      balance: "",
      equivalence: "",
      canConvert: false,
      convertType: "",
      keyword: "",
      transactionType: null,
      options: [
        {
          value: null,
          text: this.$t("dashboard.details.type"),
        },
      ],
      date: "",
      transactions: [
        {
          date: "",
          time: "",
          transaction: "",
          amount: "",
        },
      ],
      fields: [
        {
          key: "date",
          label: this.$t("dashboard.transactions.date"),
          sortable: true,
        },
        {
          key: "time",
          label: this.$t("dashboard.transactions.time"),
        },
        {
          key: "transaction",
          label: this.$t("dashboard.transactions.transaction"),
        },
        {
          key: "amount",
          label: this.$t("dashboard.transactions.amount"),
          sortable: true,
        },
      ],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      // 调用API获取数据
      const currentPage = this.$router.history.current.path.substring(1);

      switch (currentPage) {
        case "dashboard/recharge-details":
          this.balancePage = "recharge";
          this.balanceTitle = this.$t("dashboard.details.balance");
          this.balanceType = "usd";
          this.balance = 570;
          this.equivalence = "";
          this.canConvert = true;
          this.convertType = "USDToGCoin";
          break;
        case "dashboard/rewards-details":
          this.balancePage = "rewards";
          this.balanceTitle = this.$t("dashboard.details.rewardsBalance");
          this.balanceType = "GCoins";
          this.balance = 7681;
          this.equivalence = "";
          this.canConvert = false;
          this.convertType = "GCoinToUSD";
          break;
        case "dashboard/reserve-details":
          this.balancePage = "reserve";
          this.balanceTitle = this.$t("dashboard.details.reserveBalance");
          this.balanceType = "GCoins";
          this.balance = 8680;
          this.equivalence = 169.53;
          this.canConvert = true;
          this.convertType = "GCoinToUSD";
          break;
        case "dashboard/refer-details":
          this.balancePage = "refer";
          this.balanceTitle = this.$t("dashboard.details.referBalance");
          this.balanceType = "usd";
          this.balance = 8546;
          this.equivalence = "";
          this.canConvert = false;
          this.convertType = "GCoinToUSD";
          break;


        default:
          break;
      }
      this.balanceData = {
        balance: 570,
        rewards: 8680,
        reserve: 0,
        referGS: 0,
        referBusiness: 0,
        eventsCost: 275,
      };
      this.transactions = [];
      for (let index = 0; index < 14; index++) {
        const start = new Date(2019, 0, 1);
        const end = new Date();
        const randomDate = new Date(
          start.getTime() + Math.random() * (end.getTime() - start.getTime())
        );
        let dateFilter = randomDate;
        if (this.date) {
          dateFilter = new Date(this.date);
        }
        const dateString =
          dateFilter.getFullYear() +
          "-" +
          ("0" + (dateFilter.getMonth() + 1)).slice(-2) +
          "-" +
          ("0" + dateFilter.getDate()).slice(-2);
        const timeString =
          ("0" + randomDate.getHours()).slice(-2) +
          ":" +
          ("0" + randomDate.getMinutes()).slice(-2);
        const element = {
          date: dateString,
          time: timeString,
          transaction: "Transaction Code",
          amount: this.numberWithCommas(Math.floor(Math.random() * 10000)),
        };
        this.transactions.push(element);
      }
      // 语言切换后下拉菜单的选项和表格标题需要重新初始化一下
      this.options = [
        {
          value: null,
          text: this.$t("dashboard.details.type"),
        },
      ];
      this.fields = [
        {
          key: "date",
          label: this.$t("dashboard.transactions.date"),
          sortable: true,
        },
        {
          key: "time",
          label: this.$t("dashboard.transactions.time"),
        },
        {
          key: "transaction",
          label: this.$t("dashboard.transactions.transaction"),
        },
        {
          key: "amount",
          label: this.$t("dashboard.transactions.amount"),
          sortable: true,
        },
      ];
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    toConvert(type) {
      this.$router.push('/dashboard/' + type + '-convert');
    }
  },
  watch: {
    transactionType: function () {
      return;
    },
    date: function () {
      // 选定日期后调用API获取筛选后的数据
      this.getData();
    },
    "$i18n.locale": function () {
      this.getData();
    },
  },
};
</script>

<style>
.transaction-info {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 2rem;
  .balance-card {
    padding: 1rem 1.5rem;
    border-radius: 1rem;
    .balance-title {
      font-size: 1rem;
      font-weight: 500;
      line-height: 1.5rem;
    }
    .balance-area {
      display: flex;
      align-items: flex-start;
      .currency {
        color: #406d9a;
        font-size: 1rem;
        font-weight: 400;
        margin-right: 0.5rem;
      }
      .balance {
        color: #406d9a;
        font-size: 2.5rem;
        line-height: 2.5rem;
        font-weight: 600;
      }
      .equivalence {
        color: #687b8e;
        font-size: 1rem;
        align-self: center;
        font-weight: 400;
        margin-left: 0.5rem;
      }
    }
    .btn {
      border-radius: 0.5rem;
      padding: 0.5rem 1.5rem;
      color: white;
      font-size: 0.9rem;
      margin-top: 1rem;
    }
    .btn.USDToGCoin {
      background-color: #f6b317;
    }
    .btn.GCoinToUSD {
      background-color: #3586cb;
    }
  }
  .yellow-balance {
    background-color: #fffbf1;
    .balance-title {
      color: #ff7b00;
    }
  }
  .blue-balance {
    background-color: #e5f9ff;
  }
  .search-transaction {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    p {
      color: #3b3e51;
      font-size: 1.25rem;
      font-weight: 500;
    }
    input,
    select,
    .b-form-datepicker {
      border: 1px solid #aee2ff;
      border-radius: 0.5rem;
      padding: 0.2rem;
    }
    input {
      margin-bottom: 1rem;
      padding: 0.5rem 1rem;
      width: 100%;
      height: 50px;
    }
    .search {
      position: relative;
      width: 100%;
      input {
        width: 100%;
      }
      .search-icon {
        position: absolute;
        width: 22px;
        top: 14px;
        right: 1rem;
      }
    }
  }
}
.transaction-table {
  .sr-only {
    display: none;
  }
  .table > thead > tr > th {
    background-color: #3586cb;
    color: white;
  }
}
/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .transaction-info {
    flex-wrap: nowrap;
  }
}
</style>
